// extracted by mini-css-extract-plugin
export var container = "_52-1";
export var cornerButtonContainer = "_52-5";
export var disabled = "_52-2";
export var fileContainer = "_52-4";
export var hiddenInput = "_52-3";
export var widthContainer = "_52-0";